export default __webpack_public_path__ + "static/team-member-hinakosakawa-f448599dc293a5326c1e7c5e11ee49ed.png";